import { makeStyles } from '@material-ui/core'

const CARD_HEIGHT = 164

export const useStyles = makeStyles((theme) => ({
  teamTitle: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0),
  },
  teamParagraph: {
    marginBottom: theme.spacing(6),
  },
  teamMemberContainer: {
    display: 'grid',
    gridGap: theme.spacing(2),
    marginBottom: theme.spacing(15),
    gridTemplateColumns: 'repeat(1, 1fr)',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
  teamMemberCardLink: {
    textDecoration: 'none',
    color: 'inherit',
    position: 'relative', // ← anchor for the absolute overlay
  },
  cardWrapperExpanded: {
    zIndex: 10, // ← lift above neighboring cards while open
  },
  teamMemberCard: {
    height: CARD_HEIGHT,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.background.default,
  },
  memberImage: {
    height: CARD_HEIGHT,
  },
  teamContainer: {
    background: theme.palette.background.grey,
    width: '100vw',
    maxWidth: '100%',
    padding: theme.spacing(10),
  },
  teamMemberName: {
    fontWeight: '500',
  },
  teamMemberInfo: {
    padding: theme.spacing(4),
  },
  knowMoreButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    marginTop: 8,
    color: '#00A99D',
    font: 'inherit',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    '&:hover': { textDecoration: 'underline' },
  },
  memberExpandedInfo: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    background: theme.palette.background.default,
    padding: theme.spacing(3),
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    borderTop: '1px solid #eee',
    zIndex: 10,
  },
  sectionHeading: {
    fontWeight: 700,
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    fontSize: 16,
  },
  detailsList: {
    paddingLeft: 18,
    margin: 0,
    '& li': { marginBottom: 8, lineHeight: 1.5 },
  },
}))
